<template>
<div class="sub-page">
    <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
    <div class="sub-page-bd">
        <Form ref="form" :model="formData" :rules="rule" :label-width="100">
            <FormItem :label="$t('img_lnk')">
                <myCropImg :fixedNumber="fixedNumber" :autoCropWidthHeight="autoCropWidthHeight" @cropImgUpload="setImgLnk"></myCropImg>
            </FormItem>
            <FormItem  :label="$t('user_code')" prop="user_code">
                <Input v-model="formData.user_code" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('user_zh_cname')" prop="user_cname">
                <Input v-model="formData.user_cname" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('user_tw_cname')" prop="zh-tw_cname">
                <Input v-model="formData['zh-tw_cname']" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('user_en_cname')" prop="en_cname">
                <Input v-model="formData.en_cname" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('user_pwd')" prop="user_pwd2">
                <input style="width: 0;height:0;border: 0;float: left" type="password" />
                <Input v-model="formData.user_pwd2"  type="password" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('fix_password')" prop="fix_password">
                <Input v-model="formData.fix_password"  type="password" :placeholder="$t('input')"></Input>
            </FormItem>
            <FormItem  :label="$t('org_mobile')" prop="user_mobile">
                <Input v-model="formData.user_mobile" :placeholder="$t('input')"></Input>
            </FormItem>
            <Row>
                <Col span="8">
                    <FormItem  :label="$t('sex')" prop="user_sex">
                        <Select v-model="formData.user_sex" :placeholder="$t('select')">
                            <Option :value="item.key" v-for="(item, index) in sexs" :key="index">{{item.value}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem  :label="$t('dep')" prop="dep_id">
                        <Select v-model="formData.dep_id" :placeholder="$t('select')">
                            <Option :value="item.dep_id" v-for="(item, index) in deps" :key="index">{{item.dep_cname}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem  :label="$t('role')" prop="role_id">
                        <Select v-model="formData.role_id" :placeholder="$t('select')">
                            <Option :value="item.role_id" v-for="(item, index) in roles" :key="index">{{item.role_cname}}</Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="8">
                    <FormItem  :label="$t('birth')" prop="user_birth">
                        <DatePicker type="date" v-model="formData.user_birth" :placeholder="$t('input')" :editable="false"></DatePicker>
                    </FormItem>
                </Col>
                <!-- <Col span="8">
                    <FormItem :label="$t('auth_code')" prop="auth_key">
                        <Input v-model="formData.auth_key" :placeholder="$t('input')" @on-enter="onCardNoEnter"></Input>
                    </FormItem>
                </Col> -->
                <Col span="8">
                    <FormItem  :label="$t('cid_code')" prop="cid_code">
                        <Input v-model="formData.cid_code" :placeholder="$t('input')"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem :label="$t('zhiwei')" prop="zw_cname">
                        <Input v-model="formData.zw_cname" :placeholder="$t('input')"></Input>
                    </FormItem>
                </Col>
            </Row>
            <!-- <Row>
                <Col span="8">
                    <FormItem  :label="$t('jingyan')" prop="zw_jingyan">
                        <Input v-model="formData.zw_jingyan" :placeholder="$t('input')"></Input>
                    </FormItem>
                </Col>
            </Row> -->
            <FormItem :label="$t('zhineng')" prop="zw_zhineng">
                <Input v-model="formData.zw_zhineng" type="textarea" :autosize="{minRows: 5,maxRows: 10}" :placeholder="$t('input')"></Input>
            </FormItem>
        </Form>
    </div>
    <div class="sub-page-ft">
        <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
        <Button type="primary" @click="submit">{{$t('save')}}</Button>
    </div>
</div>
</template>

<script>
    import myCropImg from '../../../components/myCropImg'
    export default {
        data:function(){
            return{
                relist: false,
                fixedNumber:[1,1],
                autoCropWidthHeight:[230,230],
                deps: [],
                roles: [],
                sexs:[],

                formData: {
                    img_lnk:'',
                    user_cname: '',
                    user_mobile: '',
                    dep_id: '',
                    role_id:'',
                    user_sex: '',
                    user_birth: '',
                    user_pwd: '',
                    cid_code: '',
                    user_code: '',
                    fix_password: '',
                    auth_key:'',
                    user_pwd2:'',
                    zw_cname:'',
                    zw_jingyan:'',
                    zw_zhineng:'',
                    'zh-tw_cname': '',
                    en_cname: ''
                },
                rule: {
                    user_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_mobile: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    dep_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    role_id: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    user_sex: [{required: true, message: this.$t('select'), trigger: 'change'}],
                    user_pwd2: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    user_code: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    fix_password: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    'zh-tw_cname': [{required: true, message: this.$t('input'), trigger: 'blur'}],
                    en_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            console.log('this.formData', this.formData)
            this.getInfo();
        },
        methods:{
            onCardNoEnter:function(){
                this.formData.auth_key = this.$base.getCardNo(this.formData.auth_key)
            },
            setImgLnk: function (file_path) {
                this.formData.img_lnk = file_path;
            },
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                this.$base.showLoading();
                this.$request.sendPost("user/before-add",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.deps = this.deps.concat(data.deps);
                        this.roles = this.roles.concat(data.roles);
                        this.sexs = this.sexs.concat(data.sexs);
                    }
                    else{

                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                var url = "user/add";
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        if(this.formData.fix_password != this.formData.user_pwd2) {
                            this.$base.alertErr(this.$t('no_pwd'));
                            return;
                        }
                        this.formData.user_pwd = this.$base.toMD5(this.formData.user_pwd2);
                        if(this.formData.user_birth) {
                            this.formData.user_birth = this.$moment(this.formData.user_birth).format("YYYY-MM-DD");
                        }
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        },
        components: {
            myCropImg
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/org/user/user_add.vue